import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_JSON_FORM_MUTATION_KEY,
  type FillJsonFormDemoRequest,
  type FillJsonFormDemoResponse,
} from '../../contracts';
import { fillJsonFormDemo } from '../api/templates';

export function useMutateFillJsonFormDemo() {
  return useMutation<FillJsonFormDemoResponse, Error, FillJsonFormDemoRequest>({
    mutationKey: DEMO_FILL_JSON_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillJsonFormDemo(request);
      return data;
    },
  });
}
